import React from 'react'
import {DataObjectId, Subtask} from 'yougile-model'
import {cn} from '@containers/html-utils'
import BottomIcon from './bottom.svg'
import MiddleIcon from './middle.svg'
import RightIcon from './right.svg'
import StraightIcon from './straight.svg'
import {getStraightLinesIcons} from './subtasks-in-report'
import TopExtraIcon from './top-extra.svg'

export const Dash = (props: {
  hasSubtasks?: boolean
  taskId: DataObjectId
  hasStraightLine: boolean[]
  itemsY: Subtask[]
  flex?: boolean
  numberOfStraightLines?: number
  rightClassName?: string
  mainClassName?: string
  doesAtLeastOneOfChildSubtasksHaveSubtasks?: boolean
}) => {
  const itemY = props.itemsY.find(el => el.id === props.taskId)
  const isLast = itemY?.id === props.itemsY[props.itemsY.length - 1]?.id
  const ml = 40 * (props.hasStraightLine.length - 1)
  if (!props.hasStraightLine.length) {
    return null
  }

  return (
    <>
      {props.hasStraightLine
        .filter((_el, i) => i !== props.hasStraightLine.length - 1)
        .map((hasStraightLine, ix) => {
          const ml = 40 * ix
          return (
            hasStraightLine && (
              <div
                key={ix}
                className="absolute mt-4 text-third-old"
                style={{
                  marginLeft: ml === 0 ? 4 : ml + 4
                }}
              >
                {props.flex ? (
                  getStraightLinesIcons(props.numberOfStraightLines ?? 0)
                ) : (
                  <StraightIcon />
                )}
              </div>
            )
          )
        })}
      <div
        className={cn(
          'flex text-third-old',
          !props.flex && 'items-center',
          props.mainClassName
        )}
        style={{
          marginLeft: ml === 0 ? 4 : ml + 4
        }}
      >
        <div
          className={cn(
            props.rightClassName,
            props.hasSubtasks && 'w-16 mr-4 overflow-hidden ml-16 mt-4',
            !props.hasSubtasks &&
              !props.doesAtLeastOneOfChildSubtasksHaveSubtasks
              ? 'w-24 mr-4 overflow-hidden ml-16 mt-4'
              : 'mr-12 ml-16 mt-4 overflow-hidden w-32'
          )}
          style={{marginTop: props.flex ? 9 : undefined}}
        >
          <RightIcon />
        </div>
        <div className={cn('absolute', !props.flex && 'mt-4')}>
          {isLast ? (
            <>
              {props.flex && (
                <div className="absolute -mt-4 text-third-old">
                  <TopExtraIcon />
                </div>
              )}
              <BottomIcon />
            </>
          ) : (
            <>
              <MiddleIcon />
              {props.flex &&
                getStraightLinesIcons(props.numberOfStraightLines ?? 0)}
            </>
          )}
        </div>
      </div>
    </>
  )
}
